import { render, staticRenderFns } from "./Device.version.2.vue?vue&type=template&id=7642bd2a&scoped=true&"
import script from "./Device.version.2.vue?vue&type=script&lang=js&"
export * from "./Device.version.2.vue?vue&type=script&lang=js&"
import style0 from "./Device.version.2.vue?vue&type=style&index=0&id=7642bd2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7642bd2a",
  null
  
)

export default component.exports